import { render, staticRenderFns } from "./BatchSetBtnsAttr.vue?vue&type=template&id=62b69df0&"
import script from "./BatchSetBtnsAttr.vue?vue&type=script&lang=js&"
export * from "./BatchSetBtnsAttr.vue?vue&type=script&lang=js&"
import style0 from "./BatchSetBtnsAttr.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports